import { InjectionToken, type Provider } from '@angular/core';
import type { Observable } from 'rxjs';
import type { PctHttpErrorResponse } from './http/pct-http-error-response';

/**
 * We handle Http errors. If we want to extend the http error code handling then we should implement
 * it here
 */
export type TransformHttpErrorToPtHttpErrorResponseFn = (
  error: PctHttpErrorResponse,
  options: HttpErrorOptions,
) => Observable<PctHttpErrorResponse>;

/**
 * Handle errors with a dialog towards the user. If you want to extend or implement `TransformHttpErrorToPtHttpErrorResponseFn`
 * then you can handle special http exceptions here
 */
export type HandleIdentifiedErrorFn = (
  error: PctHttpErrorResponse,
  options: HttpErrorOptions,
) => Observable<PctHttpErrorResponse>;

export interface HttpErrorOptions {
  i18n?: {
    /**
     * Messages scope
     */
    prefix?: string;
    /**
     * Reload dialog buttons translate key
     */
    reloadKey?: string;
  };
  transformHttpErrorToPtHttpErrorResponseFn?: TransformHttpErrorToPtHttpErrorResponseFn;
  handleIdentifiedErrorFn?: HandleIdentifiedErrorFn;
}

export const HTTP_ERROR_OPTIONS = new InjectionToken<HttpErrorOptions>('HTTP_ERROR_OPTIONS');

/**
 * Need to inject it into AppConfig if we want to override the default http error handling
 */
export function provideHttpErrorOptions(options: HttpErrorOptions): Provider {
  return {
    provide: HTTP_ERROR_OPTIONS,
    useValue: options,
  };
}
